import * as Sentry from '@sentry/react';
import {
    IS_LIVE_PROD,
    IS_EDITOR_MODE,
    SENTRY_REACT_DSN,
    SENTRY_TRACES_SAMPLE_RATE,
    IS_DEV
} from 'config/envVariable';
import {
    isOneOfErrors,
    isChunkLoadError,
    isFetchNetworkError
} from 'client/utils/errorObjectChecker';

export function initErrorLogService() {
    if (IS_LIVE_PROD || IS_DEV) {
        const DEFAULT_TRACES_SAMPLE_RATE = 0.00001;
        const tracesSampleRate = isNaN(parseFloat(SENTRY_TRACES_SAMPLE_RATE))
            ? DEFAULT_TRACES_SAMPLE_RATE
            : parseFloat(SENTRY_TRACES_SAMPLE_RATE) || DEFAULT_TRACES_SAMPLE_RATE;

        Sentry.init({
            dsn: SENTRY_REACT_DSN,
            environment: IS_LIVE_PROD ? 'production' : 'dev',
            normalizeDepth: 8,
            maxBreadcrumbs: 80,
            integrations(integrations) {
                return [
                    ...integrations.filter(i => i.name !== 'GlobalHandlers'),
                    Sentry.browserTracingIntegration()
                ];
            },
            beforeSend(event, hint) {
                const { originalException = {}, captureContext: { extra } = {} } = hint;

                // 在編輯器模式下，我們特別想要捕獲主動抛出的錯誤
                if (IS_EDITOR_MODE && originalException.isActivelyCatchErr) {
                    console.log('Sentry: Capturing editor error', { event, hint });
                    return event;
                }

                // 對於非編輯器模式，使用原本的過濾邏輯
                if (
                    isNetworkResourceError(originalException) ||
                    isNetworkResourceError(extra) ||
                    !originalException.isActivelyCatchErr
                ) {
                    return null;
                }
                return event;
            },
            tracesSampleRate
        });
    }
}

export function sentryCaptureException(err) {
    try {
        const options = { extra: { ...(err.extraInfo ?? {}), deviceDate: new Date().toString() } };
        err.isActivelyCatchErr = true;

        return Sentry.captureException(err, options);
    } catch (error) {
        console.error('Error on sentry capture:', error);
        return null;
    }
}
function isNetworkResourceError(errObj = {}) {
    return isOneOfErrors([isChunkLoadError, isFetchNetworkError], errObj);
}
